import { Calendar, TrendingUp } from "lucide-react";

const sel = "rounded-md border border-zinc-800 bg-[#111112] px-3 py-2 text-sm text-slate-200 outline-none focus:border-[#C5A059]/60";
const iso = (d) => d.toISOString().slice(0, 10);

export const PRESETS = {
  today: "Oggi", yesterday: "Ieri", last7: "Ultimi 7 giorni", last30: "Ultimi 30 giorni", this_month: "Questo mese", last_month: "Mese scorso", last90: "Ultimi 90 giorni", custom: "Personalizzato",
};

export function presetRange(preset) {
  const now = new Date();
  const today = iso(now);
  if (preset === "today") return { start: today, end: today };
  if (preset === "yesterday") { const y = iso(new Date(now.getTime() - 86400000)); return { start: y, end: y }; }
  if (preset === "last7") return { start: iso(new Date(now.getTime() - 6 * 86400000)), end: today };
  if (preset === "last30") return { start: iso(new Date(now.getTime() - 29 * 86400000)), end: today };
  if (preset === "last90") return { start: iso(new Date(now.getTime() - 89 * 86400000)), end: today };
  if (preset === "this_month") return { start: iso(new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))), end: today };
  if (preset === "last_month") {
    const first = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
    const last = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0));
    return { start: iso(first), end: iso(last) };
  }
  return null;
}

export default function PeriodBar({ period, setPeriod, pipelineId, setPipelineId, pipelines, hidePipeline = false }) {
  const setPreset = (v) => setPeriod((p) => ({ ...p, preset: v, ...(presetRange(v) || {}) }));
  return (
    <div className="filters flex flex-wrap items-center gap-3 border-b border-zinc-800/70 pb-4" data-testid="period-bar">
      <span className="inline-flex items-center gap-1.5 text-sm text-slate-400"><Calendar className="h-4 w-4" /> Periodo:</span>
      <select data-testid="filter-period" value={period.preset} onChange={(e) => setPreset(e.target.value)} className={sel}>
        {Object.entries(PRESETS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
      {period.preset === "custom" && (
        <>
          <input type="date" value={period.start} data-testid="filter-start" onChange={(e) => setPeriod((p) => ({ ...p, start: e.target.value }))} className={sel} />
          <span className="text-slate-500">→</span>
          <input type="date" value={period.end} data-testid="filter-end" onChange={(e) => setPeriod((p) => ({ ...p, end: e.target.value }))} className={sel} />
        </>
      )}
      {!hidePipeline && (<>
      <span className="ml-2 inline-flex items-center gap-1.5 text-sm text-slate-400"><TrendingUp className="h-4 w-4" /> Pipeline:</span>
      <select data-testid="filter-pipeline" value={pipelineId} onChange={(e) => setPipelineId(e.target.value)} className={sel}>
        <option value="all">Tutte le pipeline</option>
        {pipelines.map((p) => <option key={p.ghl_id} value={p.ghl_id}>{p.name}</option>)}
      </select>
      </>)}
    </div>
  );
}
